import { render, staticRenderFns } from "./currencyReview.vue?vue&type=template&id=0ce3a82a&"
import script from "./currencyReview.vue?vue&type=script&lang=js&"
export * from "./currencyReview.vue?vue&type=script&lang=js&"
import style0 from "./currencyReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "currencyReview.vue"
export default component.exports